import { useTranslator } from '@bluebeam/react-i18n';
import classnames from 'classnames';
import React from 'react';
import camelCase from 'lodash/camelCase';

interface Props {
  status: 'Draft' | 'Open' | 'Closed';
}

const OfficialQuestionLabelStatus: React.FC<Props> = (props: Props) => {
  const { translate } = useTranslator(['rfiPage']);
  const { status } = props;
  const statusKey: `${string}:${string}` =
    `rfiPage:rfiDetails.rfiStatus.${camelCase(
      status
    )}` as `${string}:${string}`;
  const translatedStatus = translate(statusKey);

  return (
    <div
      className={classnames('b-2 px3 py1 font-size-4', {
        'b-2': status === 'Draft',
        'b-radius-3 bgd-status-red black-1 regular': status === 'Open',
        'b-radius-3 bgd-light-grey-1 black-1 regular': status === 'Closed',
      })}
    >
      {translatedStatus}
    </div>
  );
};

export default OfficialQuestionLabelStatus;
